import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ClockIcon, LockIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const cartUrl = 'https://competirsinmiedo.com/cart/add?id=45092891263029&quantity=1';
  return <section className="py-20 md:py-28 bg-[#f8f9fa] relative overflow-hidden" id="offer" data-id="element-126">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10" data-id="element-127">
        <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden" data-id="element-128">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-129">
            {/* Left side: Product Visual */}
            <div className="bg-[#1a1a2e] p-8 md:p-12 flex flex-col items-center justify-center relative" data-id="element-130">
              <motion.div initial={{
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4
            }} className="relative z-10 w-full max-w-[240px]" data-id="element-131">
                <div className="relative aspect-[3/4] w-full" data-id="element-132">
                  <img src="https://cdn.magicpatterns.com/uploads/kPXLbtysZ3qg94JkWcaGFV/WhatsApp_Image_2026-03-31_at_00.12.25.jpg" alt="Competir Sin Miedo - Guía + 9 Bonos" className="w-full h-full object-cover rounded-xl border border-white/10" loading="lazy" data-id="element-133" />
                </div>
              </motion.div>

              <div className="mt-8 text-center relative z-10" data-id="element-134">
                <div className="inline-flex items-center justify-center px-4 py-2 bg-white/5 rounded-full text-white/90 text-sm font-medium border border-white/10" data-id="element-135">
                  <ClockIcon className="w-4 h-4 mr-2 text-white/60" data-id="element-136" />
                  Acceso digital inmediato
                </div>
              </div>
            </div>

            {/* Right side: Checkout Info */}
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-137">
              <div className="inline-block bg-[#f8f9fa] text-brand-slate font-medium px-3 py-1 rounded-full text-xs tracking-wide uppercase mb-6 w-max border border-gray-100" data-id="element-138">
                70% DE DESCUENTO
              </div>

              <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-3 leading-tight" data-id="element-139">
                Acceso Completo
              </h2>
              <p className="text-base md:text-lg text-brand-slate-light mb-6 leading-relaxed" data-id="element-140">
                Recibe un método claro, herramientas aplicables y bonos pensados
                para acompañar el proceso completo hoy.
              </p>
              <p className="text-brand-amber font-semibold text-xs tracking-wide uppercase mb-8" data-id="element-141">
                ¡AYÚDALO ANTES DE SU PRÓXIMO JUEGO!
              </p>

              <div className="flex items-end gap-4 mb-3" data-id="element-142">
                <span className="text-4xl md:text-5xl font-heading text-brand-slate leading-none" data-id="element-143">
                  €17.99
                </span>
                <span className="text-xl text-brand-slate-muted line-through mb-1" data-id="element-144">
                  €118.00
                </span>
              </div>

              <p className="text-sm text-brand-slate-muted mb-8" data-id="element-145">
                Pago seguro. Acceso inmediato tras la compra.
              </p>

              <a href={cartUrl} onClick={trackAddToCart} className="w-full flex justify-center items-center px-8 py-4 text-base md:text-lg font-semibold text-white bg-brand-amber hover:bg-brand-amber-dark rounded-xl transition-colors duration-200 mb-4 text-center" data-id="element-146">
                Acceder Ahora por Solo €17.99 →
              </a>
              <p className="font-medium text-sm text-center mb-8 text-brand-slate-light" data-id="element-147">
                La confianza de tu hijo empieza con este clic
              </p>

              <div className="space-y-4" data-id="element-148">
                <div className="flex items-center justify-center gap-2 text-sm text-brand-slate-muted" data-id="element-149">
                  <LockIcon className="w-4 h-4 text-brand-slate-muted" data-id="element-150" />
                  <span data-id="element-151">Pago 100% seguro y encriptado</span>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-100 flex items-start gap-4" data-id="element-152">
                <ShieldCheckIcon className="w-8 h-8 text-brand-slate flex-shrink-0 mt-1" data-id="element-153" />
                <div data-id="element-154">
                  <h4 className="font-medium text-brand-slate text-base" data-id="element-155">
                    Garantía de Satisfacción
                  </h4>
                  <p className="text-sm text-brand-slate-light mt-1 leading-relaxed" data-id="element-156">
                    Tu compra está 100% respaldada. Si el material no te ayuda,
                    te devolvemos tu dinero.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}